import React from 'react';

const ArrowIcon = ({ color = 'white' }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.50037 12.1025C1.1587 12.1025 0.875543 11.8192 0.875433 11.4776C0.875433 11.1359 1.15863 10.8527 1.50037 10.8527H9.96881L1.01811 1.90196C0.776515 1.66036 0.776515 1.25967 1.01811 1.01808C1.25974 0.776794 1.6605 0.776585 1.90199 1.01808L10.8527 9.96878L10.7505 1.49988C10.7505 1.15811 11.0337 0.874945 11.3754 0.874945C11.5461 0.869086 11.7048 0.946152 11.8167 1.05794C11.9286 1.16989 12.0004 1.3231 12.0004 1.49988L12.1019 11.4776C12.1018 11.8192 11.8186 12.1025 11.4769 12.1025H1.50037Z" fill={color}/>
  </svg>
);

export default ArrowIcon;
